import React from "react";
import useSelfPayDiscount from "./hooks/useSelfPayDiscount";



/* eslint-disable react/prop-types */
const DetailsEstimateBreakdownSelfPay = props => {
    const { benefitDetails} = props;
    const bd = benefitDetails[0];//benefitDetails &&
    const { patientFinancialResponsibility } = bd.patientFinancialResponsibilityDetail;
    const discount = useSelfPayDiscount(bd.providerInformation.environment);
    const realAmount = Number(patientFinancialResponsibility) / Number(discount);
    const discountAmount = realAmount - patientFinancialResponsibility;


    console.info(`DetailsEstimateBreakdownSelfPay props`, props);
    return <React.Fragment><div className={`row estimate-details-panel`}>
        <div className="col">
            <div className="row">
                <div className="col"><h4 className="heading">Estimate Breakdown:</h4></div>
            </div>
                
            <div className={`row `}>
                <div className="col-6 label">Total Cost:</div>
                <div className="col-6 text-right">{formatMoney(realAmount)}</div>
            </div>
            <div className={`row `}>
                <div className="col-6 label">Self-Pay Discount:</div>
            <div className="col-6 text-right">{formatMoney(discountAmount)}</div>
            </div>
            <div className="row">
                <div className="col-12">
                    <hr className="hr-divider" />
                </div>
            </div>
            <div className={`row estimate-total `}>
                <div className="col-9 label">Your Out-of-Pocket Estimate:</div>
                <div className="col-3 label text-right">{formatMoney(patientFinancialResponsibility)}</div>
            </div>
        
        </div>
    </div>
    </React.Fragment>;

}
/* eslint-enable react/prop-types*/
const formatMoney = (amount) => {
    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    return formatter.format(amount);
}


export default DetailsEstimateBreakdownSelfPay;